import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGift,
  faLocationDot,
  faWallet,
  faPhone,
  faTrash,
  faInfo,
  faHeart,
  faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';

// FrontCard component - displays business name and logo
export const FrontCard = ({ color, oldColor, textColor, oldTextColor, name, oldName, logo, oldLogo, displayName, oldDisplayName }) => {
  return (
    <div
      className="frontCard"
      style={{
        alignContent: "flex-end",
        backgroundColor: color || oldColor || "#0caa41",
        color: textColor || oldTextColor || "#000000",
        flexDirection: "row",
      }}
    >
      <p
        className="cardName"
        style={{
          opacity: `${displayName !== undefined
            ? displayName
              ? "1"
              : "0"
            : oldDisplayName
              ? "1"
              : "0"
            }`,
        }}
      >
        {name || oldName}
      </p>
      <img
        id="cardLoadedLogo"
        src={logo || oldLogo}
        onChange={() => {
          document.querySelector(".imgBBError").style.display = "none";
        }}
        alt=""
      />
    </div>
  );
};

// BackCardExplore component - displays offers and action buttons for card exploration
export const BackCardExplore = ({
  color,
  oldColor,
  textColor,
  oldTextColor,
  // cardInfo state is now managed internally
  offerMsgs,
  oldOfferMsgs,
  defaultOfferMsgs,
  offer,
  oldOffer,
}) => {
  const [cardInfo1, setCardInfo1] = useState(false);
  const renderOfferContent = () => {
    if (
      (offerMsgs && offerMsgs.length === 6) ||
      (!offerMsgs && oldOfferMsgs && oldOfferMsgs.length === 6)
    ) {
      return (
        <div id="cardOffersContent">
          {defaultOfferMsgs[offer !== "0" ? offer : oldOffer]}
        </div>
      );
    } else if (!offerMsgs || (offerMsgs && offerMsgs.length === 6)) {
      return (
        <div id="cardOffersContent">
          <div>{oldOfferMsgs.split(";!#")[0]}</div>
          <div>{oldOfferMsgs.split(";!#")[1]}</div>
          <div>{oldOfferMsgs.split(";!#")[2]}</div>
        </div>
      );
    } else {
      return (
        <div id="cardOffersContent">
          <div>{offerMsgs.split(";!#")[0]}</div>
          <div>{offerMsgs.split(";!#")[1]}</div>
          <div>{offerMsgs.split(";!#")[2]}</div>
        </div>
      );
    }
  };

  return (
    <div
      className="backCardExplore"
      style={{
        backgroundColor: color || oldColor || "#0caa41",
        color: textColor || oldTextColor || "#000000",
        opacity: !cardInfo1 ? 1 : 0,
        visibility: !cardInfo1 ? "visible" : "hidden",
      }}
    >
      <div
        id="cardOffers"
        style={{
          backgroundColor: `color-mix(in srgb, ${color || oldColor || "#0caa41"} 70%, white 15%)`,
        }}
      >
        <div
          id="cardOffersTitle"
          style={{
            backgroundColor: `color-mix(in srgb, ${color || oldColor || "#0caa41"} 80%, white 5%)`,
          }}
        >
          <FontAwesomeIcon
            icon={faGift}
            style={{
              fontSize: "1.4rem",
              marginRight: "1rem",
            }}
          />
          Offres de fidélité
        </div>
        {renderOfferContent()}
      </div>
      <div className="cardIcons">
        <div
          className="cardAddress"
          style={{
            backgroundColor: `color-mix(in srgb, ${color || oldColor || "#0caa41"} 70%, white 15%)`,
          }}
        >
          <FontAwesomeIcon
            icon={faLocationDot}
            style={{ fontSize: "1.35rem", color: "" }}
          />
          Adresse
        </div>
        <div
          className="cardAdd"
          style={{
            backgroundColor: `color-mix(in srgb, ${textColor || oldTextColor || "#0caa41"} 90%, white 5%)`,
            color: color || oldColor || "#000000",
          }}
        >
          <FontAwesomeIcon
            icon={faWallet}
            style={{ fontSize: "1.35rem", color: "" }}
          />
          Ajouter
        </div>
        <div
          className="cardPhone"
          style={{
            backgroundColor: `color-mix(in srgb, ${color || oldColor || "#0caa41"} 70%, white 15%)`,
          }}
        >
          <FontAwesomeIcon
            icon={faPhone}
            style={{ fontSize: "1.35rem", color: "" }}
          />
          Appeler
        </div>
      </div>
    </div>
  );
};

// BackCardWallet component - displays card with squares and info overlay
export const BackCardWallet = ({
  color,
  oldColor,
  textColor,
  oldTextColor,
  squaresRow1,
  squaresRow2,
  squaresRow3,
  name,
  oldName,
  offerMsgs,
  oldOfferMsgs,
  defaultOfferMsgs,
  offer,
  oldOffer,
  cardNb
}) => {
  const [cardInfo2, setCardInfo2] = useState(false);
  const renderOfferContent = () => {
    if (!offerMsgs && !oldOfferMsgs) return null;

    if (
      (offerMsgs && offerMsgs.length === 6) ||
      (!offerMsgs && oldOfferMsgs && oldOfferMsgs.length === 6)
    ) {
      return (
        <div id="cardOffersContent">
          {defaultOfferMsgs[offer !== "0" ? offer : oldOffer]}
        </div>
      );
    } else if (!offerMsgs || (offerMsgs && offerMsgs.length === 6)) {
      return (
        <div id="cardOffersContent">
          <div>{oldOfferMsgs.split(";!#")[0]}</div>
          <div>{oldOfferMsgs.split(";!#")[1]}</div>
          <div>{oldOfferMsgs.split(";!#")[2]}</div>
        </div>
      );
    } else {
      return (
        <div id="cardOffersContent">
          <div>{offerMsgs.split(";!#")[0]}</div>
          <div>{offerMsgs.split(";!#")[1]}</div>
          <div>{offerMsgs.split(";!#")[2]}</div>
        </div>
      );
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        className="backCardWallet"
        style={{
          backgroundColor: color || oldColor || "#0caa41",
          color: textColor || oldTextColor || "#000000",
          //opacity: !cardInfo2 ? 1 : 0,
          visibility: !cardInfo2 ? "visible" : "hidden",
        }}
      >
        <div id="cardSquares">{squaresRow1}</div>
        <div id="cardSquares">{squaresRow2}</div>
        <div id="cardSquares">{squaresRow3}</div>

        <div className="cardIcons">
          <FontAwesomeIcon
            icon={faTrash}
            style={{ fontSize: "1.35rem", color: "" }}
          />
          <FontAwesomeIcon
            icon={faInfo}
            onClick={() => setCardInfo2(true)}
            style={{ fontSize: "1.35rem", color: "", cursor: "pointer", width: "2rem" }}
          />
          <FontAwesomeIcon
            icon={faHeart}
            style={{ fontSize: "1.35rem", color: "" }}
          />
        </div>
        <div id="cardNb">{cardNb}</div>
      </div>
      <div
        id=""
        className="backCardWallet-info"
        style={{
          backgroundColor: color || oldColor || "#0caa41",
          color: textColor || oldTextColor || "#000000",
          position: "absolute",
          top: "0",
          opacity: cardInfo2 ? 1 : 0,
          visibility: cardInfo2 ? "visible" : "hidden",
        }}
      >
        <div className="backCardWallet-info-header">
          <FontAwesomeIcon
            icon={faArrowLeft}
            onClick={() => setCardInfo2(false)}
            style={{ fontSize: "1.4rem", marginLeft: "-1rem", cursor: "pointer" }}
          />
          <p>{name || oldName}</p>
        </div>
        <div className="backCardWallet-info-content">
          <div
            id="cardOffers"
            style={{
              backgroundColor: `color-mix(in srgb, ${color || oldColor || "#0caa41"} 70%, white 15%)`,
            }}
          >
            <div
              id="cardOffersTitle"
              style={{
                backgroundColor: `color-mix(in srgb, ${color || oldColor || "#0caa41"} 80%, white 5%)`,
              }}
            >
              <FontAwesomeIcon
                icon={faGift}
                style={{
                  fontSize: "1.4rem",
                  marginRight: "1rem",
                }}
              />
              offres de fidélité
            </div>
            {renderOfferContent()}
          </div>
          <div className="cardIcons">
            <div
              className="cardAddress"
              style={{
                backgroundColor: `color-mix(in srgb, ${color || oldColor || "#0caa41"} 70%, white 15%)`,
              }}
            >
              <FontAwesomeIcon
                icon={faLocationDot}
                style={{ fontSize: "1.35rem", color: "" }}
              />
              Adresse
            </div>

            <div
              className="cardPhone"
              style={{
                backgroundColor: `color-mix(in srgb, ${color || oldColor || "#0caa41"} 70%, white 15%)`,
              }}
            >
              <FontAwesomeIcon
                icon={faPhone}
                style={{ fontSize: "1.35rem", color: "" }}
              />
              Appeler
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
